<template>
  <div>
    <div style="display: flex; width: 100%">
      <div @click="routerTo1()" id="tb1" style="width: 50%; height: 350px"></div>
      <div @click="routerTo2()" id="tb2" style="width: 50%; height: 350px"></div>
    </div>
    <div
      @click="routerTo3()"
      id="tb33"
      style="width: 100%; height: 350px; margin-top: 20px"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["rcqs", "isTrue"],
  data() {
    return {};
  },
  watch: {
    isTrue(val) {
      if (val == true) {
        this.getRcrzqs();
        this.getFwgd();
        this.getFwpJ();
      }
    },
  },
  methods: {
    routerTo1() {
      this.$router.push({ path: "/index/apartment/repair" });
    },
    routerTo2() {
      this.$router.push({ path: "/index/apartment/jiazhen" });
    },
    routerTo3() {
      this.$router.push({ path: "/index/apartment/evaluationRecord" });
    },
    getRcrzqs() {
      let myChart = this.echarts.init(document.getElementById("tb1"), "dark");
      setTimeout(() => {
        this.$http.get("/api/screen/getMonthRepair").then((res) => {
          let data = [
            {
              value: res.data.data.已派单,
              name: "已派单",
            },
            {
              value: res.data.data.已完成,
              name: "已完成",
            },
            {
              value: res.data.data.未派单,
              name: "未派单",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "本月维修工单",
            },
            tooltip: {
              trigger: "item",
            },
            legend: {
              top: "5%",
              left: "center",
            },
            color: ["#D9001B", "#6300BF", "#02A7F0"],
            series: [
              {
                name: "本月维修工单",
                type: "pie",
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: "#fff",
                  borderWidth: 2,
                },
                label: {
                  show: false,
                  position: "center",
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: "40",
                    fontWeight: "bold",
                  },
                },
                labelLine: {
                  show: false,
                },
                data: data,
              },
            ],
          };
          // 	backgroundColor: '#0F0B26',
          // 	title: {
          // 		text: '本月维修工单'
          // 	},
          // 	tooltip: {
          // 		trigger: 'item',
          // 		formatter: "{a} <br/>{b} : {c}"
          // 	},
          // 	color:['#D9001B', '#6300BF', '#02A7F0'],
          // 	series: [{
          // 		name: '人才信息',
          // 		type: 'pie',
          // 		radius: '40%',
          // 		data: data,
          // 		avoidLabelOverlap: true, //图饼标签false重复
          // 		emphasis: {
          // 			itemStyle: {
          // 				shadowBlur: 10,
          // 				shadowOffsetX: 0,
          // 				shadowColor: 'rgba(0, 0, 0, 0.5)'
          // 			}
          // 		},
          // 		itemStyle: {
          // 			normal: {
          // 				label: {
          // 					show: true,
          // 					formatter: '{b} : {c} '
          // 				},
          // 				labelLine: {
          // 					show: true
          // 				}
          // 			},
          // 		}
          // 	}]
          // }
          myChart.setOption(option);
        });
      }, 100);
    },
    getFwgd() {
      let myChart = this.echarts.init(document.getElementById("tb2"), "dark");
      setTimeout(() => {
        this.$http.get("/api/screen/getMonthService").then((res) => {
          let data = [
            {
              value: res.data.data.家政服务已完成,
              name: "已完成",
            },
            {
              value: res.data.data.家政服务未完成,
              name: "未完成",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "本月家政服务工单",
            },
            tooltip: {
              trigger: "item",
            },
            legend: {
              top: "5%",
              left: "center",
            },
            color: ["#D9001B", "#00FFFF"],
            series: [
              {
                name: "本月家政服务工单",
                type: "pie",
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: "#fff",
                  borderWidth: 2,
                },
                label: {
                  show: false,
                  position: "center",
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: "40",
                    fontWeight: "bold",
                  },
                },
                labelLine: {
                  show: false,
                },
                data: data,
              },
            ],
          };

          // let option = {
          // 	backgroundColor: '#0F0B26',
          // 	title: {
          // 		text: '本月家政服务工单'
          // 	},
          // 	tooltip: {
          // 		trigger: 'item',
          // 		formatter: "{a} <br/>{b} : {c}"
          // 	},
          // 	color:['#D9001B', '#00FFFF',],
          // 	series: [{
          // 		name: '人才信息',
          // 		type: 'pie',
          // 		radius: '40%',
          // 		data: data,
          // 		avoidLabelOverlap: true, //图饼标签false重复
          // 		emphasis: {
          // 			itemStyle: {
          // 				shadowBlur: 10,
          // 				shadowOffsetX: 10,
          // 				shadowColor: 'rgba(0, 0, 0, 0.5)'
          // 			}
          // 		},
          // 		itemStyle: {
          // 			normal: {
          // 				label: {
          // 					show: true,
          // 					formatter: '{b} : {c} '
          // 				},
          // 				labelLine: {
          // 					show: true
          // 				}
          // 			},
          // 		}
          // 	}]
          // }
          myChart.setOption(option);
        });
      }, 100);
    },
    getFwpJ() {
      let myChart = this.echarts.init(document.getElementById("tb33"), "dark");
      console.log(myChart);
      setTimeout(() => {
        this.$http.get("/api/screen/getSuggest").then((res) => {
          let data = [
            {
              value: res.data.data.未评价数,
              name: "未评价",
            },
            {
              value: res.data.data.好评数,
              name: "好评数",
            },
            {
              value: res.data.data.差评数,
              name: "差评数",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "服务评价",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c}",
            },
            color: ["#FF6E76", "#4992ff", "#7CFFB2"],
            series: [
              {
                name: "人才信息",
                type: "pie",
                radius: "50%",
                data: data,
                avoidLabelOverlap: true, //图饼标签false重复
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: "{b} : {c} ",
                    },
                    labelLine: {
                      show: true,
                    },
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        });
      }, 100);
    },
  },
};
</script>

<style scoped="scoped">
.sj {
  background-image: url(../../../assets/imgs/sjk.png) !important;
  background-repeat: no-repeat !important;
  background-size: 120% 120% !important;
}
</style>
